exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports
exports.locals = {
	"menuText": "#fff",
	"menuActiveText": "#409eff",
	"subMenuActiveText": "#fff",
	"menuBg": "#001529",
	"menuHover": "#1890ff",
	"subMenuBg": "#000c17",
	"subMenuHover": "#1890ff",
	"sideBarWidth": "210px"
};